import { Link } from "react-router-dom";
import { clinic, navLinks } from "@/data/clinic";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-content mx-auto py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-3">
                <img
                  src="https://chatgpt.com/backend-api/estuary/public_content/enc/eyJpZCI6Im1fNmFiMTZiOGMyNjQ0ODE5MWI1NGMwYmQ0NWI1NmZlYzc6ZmlsZV8wMDAwMDAwMDBhMjg4MWY1YTczZGM0MDUwOTFjZDUwMCIsImdpem1vX2lkIjpudWxsLCJ3aWQiOm51bGwsIm9pZCI6bnVsbCwic2lkIjpudWxsLCJjcyI6bnVsbCwiZm4iOm51bGwsImNkIjpudWxsLCJ0cyI6IjIwNzE3IiwicCI6InB5aSIsImNpZCI6IjEiLCJzaWciOiIyMzM1MGQ1NTdmOWU2OTZiYTY4ODMzMjgwZmFhYjJhZjMwYjVhOWE5N2JhNmRhMzQwYjA0NjJmYWU2MzU3NGMxIiwidiI6IjAiLCJjZG4iOm51bGwsImNwIjpudWxsLCJtYSI6bnVsbH0="
                  alt="Florida Family Clinic logo"
                  title="Florida Family Clinic"
                  className="w-10 h-10 rounded-full object-cover border border-primary-800"
                />
                <div className="flex flex-col leading-none">
                  <span className="font-heading text-lg font-bold text-background-50">
                    {clinic.brand}
                  </span>
                  <span className="text-[11px] tracking-[0.14em] uppercase text-secondary-300 mt-1">
                    {clinic.legalName}
                  </span>
                </div>
              </div>
              <p className="mt-5 text-sm leading-relaxed text-secondary-200 max-w-md">
                Orthopedic care, pain-related treatment, diagnostic services, and medically
                supervised wellness support in a convenient outpatient setting.
              </p>
            </div>

            <div>
              <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.14em] text-background-50 mb-4">
                Explore
              </h3>
              <ul className="space-y-3">
                {navLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-200 transition-colors duration-200 hover:text-background-50 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.14em] text-background-50 mb-4">
                Contact
              </h3>
              <ul className="space-y-3 text-sm text-secondary-200">
                <li className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-map-pin-line text-primary-300" />
                  </span>
                  <span>
                    {clinic.addressLine}
                    <br />
                    {clinic.addressCity}
                    <br />
                    {clinic.addressCountry}
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-5 h-5 flex items-center justify-center shrink-0">
                    <i className="ri-phone-line text-primary-300" />
                  </span>
                  <a
                    href={clinic.phoneHref}
                    className="transition-colors duration-200 hover:text-background-50 cursor-pointer"
                  >
                    {clinic.phone}
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <span className="w-5 h-5 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line text-primary-300" />
                  </span>
                  <a
                    href={`mailto:${clinic.email}`}
                    className="break-all transition-colors duration-200 hover:text-background-50 cursor-pointer"
                  >
                    {clinic.email}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-primary-800">
            <p className="text-sm leading-relaxed text-secondary-300 max-w-4xl">
              <strong className="text-secondary-200 font-semibold">Medical disclaimer: </strong>
              This website provides general informational content and is not a substitute for
              professional medical advice, diagnosis, or treatment. For medical emergencies, call
              911 or contact emergency services.
            </p>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-xs text-secondary-400">
              © {year} {clinic.legalName}. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-secondary-300">
              <Link
                to="/privacy-policy"
                className="transition-colors duration-200 hover:text-background-50 cursor-pointer whitespace-nowrap"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-use"
                className="transition-colors duration-200 hover:text-background-50 cursor-pointer whitespace-nowrap"
              >
                Terms of Use
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}